const EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g

// Strings
const minLength = (min: number) => (val: string) => val.length < min ? `Min Length is ${min}` : null
const isEmail = (val: string) => EMAIL_REGEX.test(val) ? null : 'Must be a valid email'

export const validators = {
  minLength,
  isEmail,
}
